import { QueryClient, QueryCache, MutationCache } from '@tanstack/vue-query';
import { handleQueryError, handleMutationError } from '@/common/utils/error.utils';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleQueryError,
  }),
  mutationCache: new MutationCache({
    onError: handleMutationError,
  }),
  defaultOptions: {
    queries: {
      gcTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      retry: 0,
    },
    mutations: {
      // 기본 gcTime(5분) 동안 MutationCache 가 mutation 결과(axios 응답 전체 — XHR·config 포함)를
      // 보관하므로, 쿼리와 동일한 즉시 폐기 정책으로 통일한다.
      gcTime: 0,
    },
  },
});
